function BulkCostMappingCtrl($state, $stateParams, $rootScope, toaster, BulkCostMappingService, CommonService, AppSettings) {
  'ngInject';
  // ViewModel
  const vm = this;
  vm.orgId = $rootScope.orgId;
  vm.bulkCostForm = {};
  vm.bulkCostMappingList = [];
  vm.pageNumber = !$stateParams.pageNumber ? 1 : $stateParams.pageNumber;
  vm.size = !$stateParams.size ? 50 : $stateParams.size;
  vm.accountId = !$stateParams.account ? '' : $stateParams.account;
  vm.sortBy = !$stateParams.sortBy? '' : $stateParams.sortBy;
  vm.sortFlag = false;
  vm.effectiveRegex = '^(([2-9]|[1-9][0-9])[m]{1}$)|^(([1-9]|10)[y]{1}$)';
  vm.regex = '^[-+]?[0-9]*\.?[0-9]+$';
  vm.loading = false;
  vm.loaderFlag = false;
  vm.dataloading = false;
  vm.disableAccountEdit = false;


  if($stateParams.bulkmappingid){
    BulkCostMappingService.getMapping($stateParams.orgId, $stateParams.bulkmappingid, function(response) {
      vm.bulkCostForm.assetType = response.data.asset_type;
      vm.bulkCostForm.expenseAccount = response.data.depreciation_account;
      vm.bulkCostForm.assetAccount = response.data.api_v1_account;
      vm.bulkCostForm.effectiveLife = response.data.effective_life;
      vm.bulkCostForm.narration = response.data.narration;
      if(vm.bulkCostForm.assetAccount && vm.bulkCostForm.effectiveLife) {
          vm.accountId = vm.bulkCostForm.assetAccount.id;
          vm.effectiveLife = vm.bulkCostForm.effectiveLife;
          BulkCostMappingService.getJournals($stateParams.orgId, vm.accountId, vm.effectiveLife, function(response){
            vm.journalHistory = response.data.bulk_cost_journals;
          });
      }
      BulkCostMappingService.getBulkCostJournalCount($stateParams.orgId, vm.accountId, function (response) {
        if(response.status == 200){
          var journal_count = response.data.journal_count + 'm';
          if(journal_count > vm.effectiveLife){
            vm.disableAccountEdit = true;
          } else {
            vm.disableAccountEdit = false;
          }
        }
      });
    });
  } else{
    vm.bulkCostForm = {};
  }

  vm.isActiveTab = function(name){
     return  $state.current.name.startsWith(name);
  }

  vm.checkValidity = function(bulkCostForm,amountPaid,required){
    let length = vm.journalHistory ? vm.journalHistory.length : 0;
    let  error = false;
    for(let x = 0 ; x < length; x++){
     if(bulkCostForm[""+amountPaid+x+""] && bulkCostForm[""+amountPaid+x+""].$error[required]){
        error = true;
        break;
     }
    }
    return error;
  }



  vm.init = function () {
    if($stateParams.orgId) {
    vm.dataloading = true;
      vm.url = `/organizations/${$stateParams.orgId}/bulk_cost_mappings.json?page=${vm.pageNumber}&size=${vm.size}&by_account=${vm.accountId}&sort=${vm.sortBy}`;
     vm.loading = true;
    BulkCostMappingService.getMappings($stateParams.orgId, vm.url, function (response) {
      vm.loading = false;
      vm.dataloading = false;
      if(response.status == 200) {
        vm.bulkMappingResponse = response.data;
        vm.currentPage = !vm.bulkMappingResponse.pagination ? 1 : vm.bulkMappingResponse.pagination.current_page;
        vm.totalPages = !vm.bulkMappingResponse.pagination ? 1 : vm.bulkMappingResponse.pagination.total_pages;
        vm.bulkCostMappingList = response.data.bulk_cost_mappings;
      }
    });
    vm.getAccounts();
    }
  };

  vm.getAccounts = function(){
   CommonService.getAccounts($stateParams.orgId, function (response) {
        vm.accounts = response.data;
         if($stateParams.account) {
         vm.account = vm.accounts.find(x => x.id == $stateParams.account);
         }
    });
  }
  vm.refreshBulkCostMapping = function(){
    vm.dataloading = true;
    vm.url = `/organizations/${$stateParams.orgId}/bulk_cost_mappings.json?page=${vm.pageNumber}&size=${vm.size}&by_account=${vm.accountId}&sort=${vm.sortBy}`;
    BulkCostMappingService.getMappings($stateParams.orgId, vm.url, function (response) {
      vm.dataloading = false;
      if(response.status == 200) {
        vm.bulkMappingResponse = response.data;
        vm.currentPage = !vm.bulkMappingResponse.pagination ? 1 : vm.bulkMappingResponse.pagination.current_page;
        vm.totalPages = !vm.bulkMappingResponse.pagination ? 1 : vm.bulkMappingResponse.pagination.total_pages;
        vm.bulkCostMappingList = response.data.bulk_cost_mappings;
      }
    });
  };

  vm.search = function (account) {
    $state.go('user.organization.settingView.mapping.bulk-mapping', {pageNumber: vm.pageNumber, account: !account? '' : account.id, size: vm.size})
  };

  vm.sortFlag = function(param) {
    var currentSort = $stateParams.sortBy;
    if(currentSort && currentSort.includes(param))
    {
      if(!currentSort.includes('-'))
      {
        return false;
      }
    }
    return true;
  };

  vm.sort = function(param) {
    var currentSort = $stateParams.sortBy;
    if(currentSort && currentSort.includes(param))
    {
      if(!currentSort.includes('-'))
      {
        param = '-' + param;
      }
    }
    $state.go('user.organization.settingView.mapping.bulk-mapping', {sortBy: param});
  };

  vm.paginate = function (param) {
    vm.url = vm.bulkMappingResponse.links[param];
    if(vm.url) {
      var arr = vm.url.split('?');
      vm.pageNumber = CommonService.getParameterByName('page', vm.url);
      vm.url = arr[0] + '.json?page=' + vm.pageNumber + '&size=' + vm.size;
      $state.go('user.organization.settingView.mapping.bulk-mapping', {pageNumber: vm.pageNumber, size: vm.size});
    }
  };

  vm.rowChange = function (param, pageSize) {
    vm.url = vm.bulkMappingResponse.links[param];
    var arr = vm.url.split('?');
    vm.pageNumber = 1;
    vm.size = pageSize;
    vm.url = arr[0]+ '.json?page='+ vm.pageNumber + '&size='+ vm.size;
    $state.go('user.organization.settingView.mapping.bulk-mapping', {pageNumber: vm.pageNumber, size: vm.size})
  };

  vm.getJournals = function() {
    if(vm.bulkCostForm.assetAccount && vm.bulkCostForm.effectiveLife) {
        vm.accountId = vm.bulkCostForm.assetAccount.id;
        vm.effectiveLife = vm.bulkCostForm.effectiveLife;
         vm.loaderFlag = true;
        BulkCostMappingService.getJournals($stateParams.orgId, vm.accountId, vm.effectiveLife, function(response){
          vm.journalHistory = response.data.bulk_cost_journals;
          vm.loaderFlag = false;
        });
    }

  }

  vm.createMapping = function (bulkCostForm) {
    vm.bulkCostForm.bulk_cost_journals = vm.journalHistory;
    vm.responseReceived = false;
    if($stateParams.bulkmappingid) {
        BulkCostMappingService.updateMapping(vm.bulkCostForm, $stateParams.orgId, $stateParams.bulkmappingid, function(response){
       if(response.status >= 200 & response.status <300) {
        vm.responseReceived = true;
        vm.bulkCostForm = {};
        bulkCostForm.$setPristine();
        bulkCostForm.$setUntouched();
        toaster.pop('info', 'Bulk cost mapping updated.');
        $state.go('user.organization.settingView.mapping.bulk-mapping', {orgId: $stateParams.orgId}, {inherit: false});
      } else {
        toaster.pop('error',CommonService.throwError(response));
       $state.go('user.organization.settingView.mapping.bulk-mapping', {orgId: $stateParams.orgId}, {inherit: false});
      }
      });
    }
    else {
      vm.responseReceived = false;
      BulkCostMappingService.createMapping(vm.bulkCostForm, $stateParams.orgId, function(response){
        if(response.status >= 200 & response.status <300) {
          vm.responseReceived = true;
          vm.bulkCostForm = {};
          bulkCostForm.$setPristine();
          bulkCostForm.$setUntouched();
          toaster.pop('info', 'New bulk cost mapping created.');
          $state.go('user.organization.settingView.mapping.bulk-mapping', {orgId: $stateParams.orgId}, {inherit: false});
        }else{
          toaster.pop('error', CommonService.throwError(response));
          $state.go('user.organization.settingView.mapping.bulk-mapping', {orgId: $stateParams.orgId}, {inherit: false});
        }
    });
    }
  };

  vm.removeMapping = function(mappingId){
    for(var i = vm.bulkCostMappingList.length - 1; i >= 0; i--){
      if(vm.bulkCostMappingList[i].id == mappingId){
        vm.refreshBulkCostMapping();
      }
    }
  };

  vm.deleteMapping = function(mappingId) {
     swal({
      title: "Are you sure?",
      text: "Do you want to delete this mapping?",
      icon: "warning",
      dangerMode: true,
      buttons: [true, true]
  })
  .then(willDelete => {
    if (willDelete) {
      BulkCostMappingService.deleteMapping(mappingId, $stateParams.orgId, function(response){
      if(response.status == 204){
        vm.removeMapping(mappingId);
        toaster.pop('info', 'Mapping deleted.');
      } else {
        toaster.pop('error', 'Mapping cannot be deleted.');
      }
      });
    }
  });
  };

  vm.editMapping = function(id) {
    $state.go('user.organization.settingView.mapping.bulkNewMapping', {orgId: $stateParams.orgId, bulkmappingid: id}, {inherit: false});
  };
}


export default {
  name: 'BulkCostMappingCtrl',
  fn: BulkCostMappingCtrl
};
